<template>

	<core-alerts
		v-if="outputErrors && error"
		:id="errorId"
		:alerts="alerts"
	/>
	<core-loading v-else-if="connectLoading" :size="loaderSize"/>
	<core-button
		v-else
		@click.prevent="handle"
		v-bind="$attrs"
	><slot>Connect</slot></core-button>

</template>

<script>
import { getAppData } from '@/utils'
import { mapState, mapActions } from 'vuex'
let triggeredId = ''
export default  {
	inheritAttrs : false,
	props        : {
		outputErrors : {
			type    : Boolean,
			default : true,
		},
		errorId : {
			type    : String,
			default : 'om-connect-errors',
		},
		buttonClass : String,
		disconnect  : {
			type    : Boolean,
			default : false,
		},
		refreshAfter : {
			type    : Boolean,
			default : true,
		},
		loaderSize : {
			type    : String,
			default : '30px',
		},
	},
	mounted () {
		this.$store.commit('clearAlerts')
		window.addEventListener('message', this.listenMessage)
	},
	beforeDestroy () {
		window.removeEventListener('message', this.listenMessage)
	},
	computed : {
		...mapState([ 'error', 'alerts' ]),
		connectLoading () {
			return this.$store.getters.isLoading([ 'connect', 'disconnect' ])
		},
	},
	methods : {
		...mapActions([ 'saveApiKey' ]),
		...mapActions({
			disconnectApiKey : 'disconnect',
		}),
		success (disconnect = false) {
			this.$emit('onSuccess', disconnect)
			if (this.refreshAfter) {
				// Put the loader back in place.
				this.$store.commit('loading', disconnect ? 'disconnect' : 'connect')
				window.location.reload()
			}
		},
		async listenMessage (evt) {
			// Only listen in if this is the button that fired the window!
			if (!triggeredId || triggeredId !== this._uid) {
				return
			}

			const { origin, data } = evt
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return
			}

			if (!data || 'string' !== typeof data) {
				console.error('Messages from "' + this.$urls.app() + '" must contain an api key string.')
				return
			}

			await this.saveApiKey(data)

			this.success()
		},
		async handle (evt) {
			triggeredId = this._uid
			if (this.disconnect) {
				await this.disconnectApiKey()

				return this.success(true)
			}

			try {
				var url = this.$urls.app('wordpress/connect/?site=' + encodeURIComponent(getAppData('blogname')))
				var w = window.open(url, '_blank', 'location=no,width=500,height=730,scrollbars=0')
				w.focus()
			} catch (e) {
				alert('Your browser blocked the authorization window from opening. Please check your popup settings.')
			}
		},
	},

}
</script>
